'use strict';

angular.module('buyers')
.directive('bottomMenu', ['$location', '$rootScope', function($location, $rootScope) {
    return {
        templateUrl : "partials/bottom-menu.html",
        restrict: 'E', // attribute
        link : function (scope, element, attrs) {
            scope.openPage = function(page) {
                if(page == 'watchlist') {
                    $rootScope.watchlistNotificationCount = 0;
                }
                $location.path('/' + page);
            }
        }
    };
}]);